import Keycloak from 'keycloak-js';

// Créer une instance Keycloak singleton pour éviter les doubles initialisations
let keycloakInstance = null;

const getKeycloakInstance = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak({
      url: "https://auth.izichange.com",
      realm: 'izichange-realm',
      clientId: 'izi-client',
    });
  }
  return keycloakInstance;
};

const keycloak = getKeycloakInstance();

export default keycloak;
